import ProgramsTable from './ProgramsTable';

export default ProgramsTable;
